import http from "@/utils/http";

export default {
  // 添加车辆信息
  insertCar: data => http.post(`/carApi/officialCar/addOrUpdate`, data),
  // 查询车辆信息
  queryCarListInfo: data =>
    http.post(`/carApi/officialCar/queryCarListInfo`, data),
  // 冻结车辆信息
  editCarListInfo: data => http.post(`/carApi/officialCar/addOrUpdate`, data),
  // 删除车辆
  deleteCarListInfo: data =>
    http.get(`/carApi/officialCar/deleteCar?id=${data}`),
  // 申请用车
  insertApplyCar: data =>
    http.post(`/carApi/officialVehicle/insertApplyCar`, data),
  // 预定车辆列表信息
  queryBookingCar: data =>
    http.post(`/carApi/officialVehicle/queryBookingCar`, data),
  // 添加同行信息
  insertPeerInfo: data => http.post(`/carApi/usePeer/insertPeerInfo`, data),
  // 我的申请列表信息
  queryMyApplication: data =>
    http.post(`/carApi/officialVehicle/queryMyApplication`, data),
  // 修改申请用车信息接口
  updateMyApplication: data =>
    http.post(`/carApi/officialVehicle/updateMyApplication`, data),
  // 查看我的用车详情
  queryUseCarDetails: data =>
    http.post(`/carApi/officialVehicle/queryUseCarDetails`, data),
  // 查询分配用车详细列表
  queryUseCarAllotList: data =>
    http.post(`/carApi/officialVehicle/queryAllocation`, data),
  // 费用详情
  queryCostDetails: data => http.post(`/carApi/useCost/queryCostDetails`, data),
  // 分配车辆
  carAllotInfo: data =>
    http.post(`/carApi/officialVehicle/vehicleAllocation`, data),
  // 获取成本中心
  departmentCode: data =>
    http.get(`/carApi/officialVehicle/useCostInfo?departmentCode=${data}`),
  //司机绑定车辆信息
  queryDriverInfo: data => http.post(`/carApi/officialCar/queryCarInfo`, data),

  //修改费用详情
  updateCostInfo: data =>
    http.post(`/carApi/officialVehicle/updateCostInfo`, data),

  // 待办行程
  queryToDoList: data =>
    http.post(`/carApi/officialVehicle/queryToDoList`, data),

  // 确认出发
  insertCarCost: data => http.post(`/carApi/useCost/addOrUpdate`, data),
  // 结束行程
  updateCarCost: data => http.post(`/carApi/useCost/updateCarCost`, data),
  // 用车明细列表
  queryUseCarList: data =>
    http.post(`/carApi/officialVehicle/queryUseCarList`, data),

  //组织部门
  queryDeptListInfo: () =>
    http.post(`/carApi/officialVehicle/queryDeptListInfo`),

  //导出
  exportExcelInfo: data =>
    http.post(`/carApi/officialVehicle/exportExcelInfo`, data, {
      responseType: "blob"
    }),

  //单个取消预约
  cancelReservation: data =>
    http.post(`/carApi/officialVehicle/cancelReservation`, data),

  // 多个取消预约
  batchCancelReservation: data =>
    http.post(`/carApi/officialVehicle/batchCancelReservation`, data),

  //获取分配车辆列表
  queryAllotCarListApi: data =>
    http.post(`/carApi/officialCar/allocationCarListInfo`, data),

  //根据工号获取姓名
  queryUserNameApi: data => http.post(`/carApi/user/queryByUsername`, data),
  //根据工号获取姓名
  freezeChangeStateApi: data =>
    http.post(`/carApi/officialCar/updateState`, data),
  //删除预约车辆申请
  deleteFlow: data => http.post(`/carApi/officialVehicle/deleteFlow`, data),
  //提交审批
  submitApprovalApi: data =>
    http.post(`/carApi/officialVehicle/submitApproval`, data),

  // 消息推送
  // 用户查询评价
  queryComment: data => http.post(`/carApi/carUseComment/queryComment`, data),
  // 用户提交评价
  addOrUpdate: data => http.post(`/carApi/carUseComment/addOrUpdate`, data),
  // 领导周报汇总
  weekCommentCountByLeader: data => http.post(`/carApi/carUseComment/weekCommentCountByLeader`, data),
  // 领导周报汇总详情页
  weekCommentCountByLeaderDetail: data => http.post(`/carApi/carUseComment/weekCommentCountByLeaderDetail`, data),
  // 司机周报汇总
  weekCommentCountByDriver: data => http.post(`/carApi/carUseComment/weekCommentCountByDriver`, data),

  // 司机评价
  queryDateRange: data => http.post(`/carApi/carUseComment/queryDateRange`, data),



  // 后台维护
  // 收藏
  updateUserZoneId: data => http.post(`/carApi/user/updateUserZoneId`, data),
  // 查询厂务
  getActiveUsersCarAdmins: data => http.post(`/carApi/user/getActiveUsersCarAdmins`, data),
  // 查询厂务管理区域
  queryByPageList: data => http.post(`/carApi/carAdminZone/queryByPageList`, data),
  // 查询厂务已有区域
  queryCarAdminZoneByPageList: data => http.post(`/carApi/carAdminZone/queryCarAdminZoneByPageList`, data),
  // 查询所有区域
  queryCarZoneByPageList: data => http.post(`/carApi/officialCar/queryCarZoneByPageList`, data),
  // 厂务模块提交
  zoneAddOrUpdate: data => http.post(`/carApi/carAdminZone/addOrUpdate`, data),
  // 用车提交
  batchUpdate: data => http.post(`/carApi/officialCar/batchUpdate`, data),
};
